//@ts-check
import axios from "axios";

export default async function sessionAlert() {
    const response = await axios.get("/web/session_time");
    const session_time = response.data;
    if (typeof session_time === "number" && session_time > 0) {
        setTimeout(function() {
            console.info("Session timed out.");
            // Show the session expired popup.
            const cwd_trigger = document.getElementById("popup-trigger");
            if (cwd_trigger) {
                cwd_trigger.click();
            } else {
                console.error("CWD Popup not found");
            }
        }, session_time);
    }
}
